import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Tag, useDeviceContext } from '@spotahome/ui-library';
import { DSIcon } from '@spotahome/ui-library/base';
import { trans, useSoyuzExperiment } from '@spotahome/soyuz/client';

import ListingSocialButtons from '@spotahome/marketplace-common/src/components/ListingSocialButtons';

import { useSliderContext } from '../../context/SliderContext';

import './MainSliderLabels.scss';

const noop = () => {};

const MainSliderLabels = ({
  listingId,
  onBackClick = noop,
  className = ''
}) => {
  const labels = useSliderContext();
  const { deviceOS } = useDeviceContext();
  const isListingSimplificationHeaderVariant =
    useSoyuzExperiment('ListingSimplificationHeader').get('behaviour') ===
    'variant';

  const wrapperClassName = classNames('main-slider-label', className);

  return (
    <div className={wrapperClassName}>
      {labels.checked ? (
        <Tag
          label={trans(labels.checked.text).toUpperCase()}
          renderLeadingIcon={() => labels.checked.icon}
          isDarkMode
          className={classNames({
            'main-slider-label__checked': isListingSimplificationHeaderVariant
          })}
        />
      ) : null}
      {isListingSimplificationHeaderVariant && (
        <>
          <Tag
            renderLeadingIcon={() => <DSIcon name="arrow_left" />}
            className="main-slider-label__back-button"
            onClick={e => {
              e.stopPropagation();
              onBackClick();
            }}
            size="big"
          />
          <ListingSocialButtons
            listingId={listingId}
            isRedesign
            className="main-slider-label__social-buttons"
            deviceOS={deviceOS}
          />
        </>
      )}
    </div>
  );
};

MainSliderLabels.propTypes = {
  listingId: PropTypes.string.isRequired,
  onBackClick: PropTypes.func,
  className: PropTypes.string
};

export default MainSliderLabels;
